import { styled } from '@material-ui/core';

import { down } from '../../../../assets/style/breakpointHelpers';

// Video thumbnail card shown on step 1, below the branded hero, when the party
// has published a promo video (showVideo && videoUrl). Colours for the play
// badge / branded frame come in as inline styles (computed from the party's
// brand) so they're correct on first paint; layout lives here.

export const VideoCardLink = styled('a')({
	// Full-width to sit flush under the hero (no dead white space beside it), but
	// capped in height so a full-bleed 16:9 doesn't tower — reads as a cinematic
	// strip. The <img> covers, so the crop stays centred at any width.
	'position': 'relative',
	'display': 'block',
	'width': '100%',
	'aspectRatio': '16 / 9',
	'maxHeight': 440,
	'borderRadius': 4,
	'overflow': 'hidden',
	'cursor': 'pointer',
	'textDecoration': 'none',
	'border': '1px solid var(--color-border-default)',
	'backgroundColor': 'var(--color-bg-secondary)',
	'boxShadow': 'var(--shadow-md)',
	'transition': 'transform 0.2s ease, box-shadow 0.2s ease',
	'&:hover': {
		transform: 'translateY(-2px)',
		boxShadow: 'var(--shadow-lg)',
	},
	'&:focus-visible': {
		outline: '3px solid var(--color-border-focus)',
		outlineOffset: 2,
	},
	'@media (prefers-reduced-motion: reduce)': {
		'transition': 'none',
		'&:hover': {
			transform: 'none',
		},
	},
	[down('sm')]: {
		maxHeight: 'none',
	},
});

export const VideoThumbImg = styled('img')({
	position: 'absolute',
	inset: 0,
	width: '100%',
	height: '100%',
	objectFit: 'cover',
	display: 'block',
});

// Fallback surface for providers with no cheap public thumbnail (Vimeo).
export const VideoBrandedFrame = styled('div')({
	position: 'absolute',
	inset: 0,
});

// Bottom scrim so the play badge + label stay legible over any thumbnail.
export const VideoOverlay = styled('div')({
	position: 'absolute',
	inset: 0,
	background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 45%, rgba(0, 0, 0, 0.45) 100%)',
});

export const VideoPlayBadge = styled('div')({
	'position': 'absolute',
	'top': '50%',
	'left': '50%',
	'transform': 'translate(-50%, -50%)',
	'display': 'flex',
	'alignItems': 'center',
	'justifyContent': 'center',
	'width': 64,
	'height': 64,
	'borderRadius': '50%',
	'boxShadow': '0 8px 20px rgba(0, 0, 0, 0.3)',
	'border': '2px solid rgba(255, 255, 255, 0.85)',
	'& svg': {
		width: 28,
		height: 28,
		marginLeft: 3,
	},
	[down('sm')]: {
		'width': 54,
		'height': 54,
		'& svg': {
			width: 24,
			height: 24,
		},
	},
});

export const VideoLabel = styled('span')({
	position: 'absolute',
	left: 16,
	bottom: 12,
	color: '#ffffff',
	fontFamily: 'var(--font-family-medium)',
	fontWeight: 500,
	fontSize: 'var(--text-body-sm-size)',
	letterSpacing: 'var(--tracking-wide)',
	textShadow: '0 1px 3px rgba(0, 0, 0, 0.5)',
});
